// Transforms enum values to be display values for UI,
// by accepting a string with underscores as token delimiters,
// and returns a title-cased string with spaces as delimiters.
// Example input: MARRIED_FILING_JOINTLY
// Returns: 'Married filing jointly'
export const transformEnumToDisplay = (input: string): string => {
    // Split the input string by underscores.
    const words = input.split('_');

    // Capitalize the first word and keep the rest in lowercase.
    const formattedWords = words.map((word, index) => {
        if (index === 0) {
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }

        return word.toLowerCase();
    });

    return formattedWords.join(' ');
};
